import RelateRecordCards from './RelateRecordCards';

export default RelateRecordCards;
